import { JSX }	from "preact";

import { Dom }	from "ts-base/web/dom";

export type FloaterButtonProps = Readonly<{
	icon:	string,
	text1:	string,
	text2:	string,
	open:	boolean,
	action:	() => void,
}>;

export const FloaterButton = ({ icon, text1, text2, open, action }:FloaterButtonProps):JSX.Element =>
	<button
		class={Dom.classes("floater-button", open && "expanded")}
		onClick={action}
	>
		<div class={`fa-light fa-${icon}`}></div>
		<div class="floater-button-text">
			<div class="floater-button-text-1">{text1}</div>
			<div class="floater-button-text-2">{text2}</div>
		</div>
	</button>;
